import React, { useContext, useEffect, useMemo } from "react";
import "./index.scss";
import { getAvailableSidesByStep } from "../../../FormulaGenerator/formulaHelpers";
import Formula3DPreview from "../../../FormulaGenerator/Formula3DPreview";
import { StepContext } from "../../StepContext";

const ClinicalView = ({
  stepId
}) => {
  const {
    dentalData,
    setFormulaBeforeTreatment
  } = useContext(StepContext);
  useEffect(() => {
    setFormulaBeforeTreatment(dentalData);
  }, [dentalData]);
  const availableSwitchers = useMemo(() => {
    return getAvailableSidesByStep(stepId);
  }, [stepId]);
  return /*#__PURE__*/React.createElement("div", {
    className: "clinicalView"
  }, /*#__PURE__*/React.createElement(Formula3DPreview, {
    stlPack: dentalData,
    availableSwitchers: availableSwitchers,
    hideNotUsedSides: false,
    hideJawStateSwitcher: false,
    jawStateEnabled: false
  }));
};

export default ClinicalView;